import React, { useState, useEffect } from "react";
import NiceButton from "components/NiceButton/NiceButton.js";
import start from "api/payment/start";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Input,
  Text,
  useDisclosure,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useColorMode,
  GridItem,
  useColorModeValue,
  FormControl,
  FormHelperText,
  FormLabel
} from "@chakra-ui/react";
import { useHistory, useLocation } from "react-router-dom";


export default (probs) => {
  const history = useHistory();
  const addCommas = (num) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // const addDot = (num) =>
  // num.toString().replace(/\B(?=() /gm, ".");
  const removeNonNumeric = (num) => num.toString().replace(/[^\d.-]+/g, "");

  const handleChange = (event) =>
    setAmount(
      addCommas(removeNonNumeric(event.target.value)) + " تومان"
    );
  const btnColor = useColorModeValue("navy.400", "navy.600");
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState("100,000 تومان");
  const { colorMode } = useColorMode();

  function call() {
    setIsLoading(true);
    start(removeNonNumeric(amount)).then((result) => {
      console.log(result.data.Url)
      window.location = (result.data.Url)
    }).catch((err) => {
      console.error(err)
      throw err
    }).finally(() => {
      setIsLoading(false);
    })
  }
  return (
    <>
      <NiceButton
        bg={btnColor}
        isLoading={isLoading}
        onClick={onOpen}
        fontSize='xs'
      >
        افزایش موجودی
      </NiceButton>
      <Modal
        isOpen={isOpen}
        onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontSize="md">افزایش موجودی</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
            <FormControl w='100%' mt={"30px"} id="text">
              <FormLabel fontSize="xs" >مبلغ مورد نظر را وارد کنید.</FormLabel>
              <Input name='text' fontSize="xs" placeholder="متن را وارد کنید." value={amount} onChange={handleChange} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose} fontSize='xs'>انصراف</Button>
            <NiceButton mr="10px"
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isLoading}
              onClick={call}
              fontSize='xs'
              w="100px">
              پرداخت
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}